module.exports = __webpack_public_path__ + "img/slag.e675c86a.png";